import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const tomos = [{
  title: '📘 TOMO 1 — Lenguaje y Comunicación Funcional',
  desc: 'Para el niño que no habla como debería, que no narra, que no comprende o que comunica pero no conecta.',
  bullets: ['Intención comunicativa', 'Vocabulario', 'Morfosintaxis', 'Narrativa', 'Pragmática', 'Emociones'],
  color: 'bg-blue-50',
  borderColor: 'border-blue-100',
  textColor: 'text-blue-900',
  bulletColor: 'text-blue-600'
}, {
  title: '📗 TOMO 2 — Conciencia Fonológica y Lectoescritura',
  desc: 'Para el niño que no lee, que lee pero no comprende, que escribe como puede o que está por empezar.',
  bullets: ['Discriminación auditiva', 'Sílabas y fonemas', 'Correspondencia grafema-fonema', 'Fluidez', 'Comprensión', 'Escritura académica'],
  color: 'bg-green-50',
  borderColor: 'border-green-100',
  textColor: 'text-green-900',
  bulletColor: 'text-green-600'
}, {
  title: '📙 TOMO 3 — Cognición y Funciones Ejecutivas',
  desc: 'Para el niño que no se organiza, que impulsea, que se olvida de todo o que no puede sentarse a hacer nada.',
  bullets: ['Atención', 'Memoria de trabajo', 'Planificación', 'Control inhibitorio', 'Flexibilidad cognitiva', 'Autorregulación'],
  color: 'bg-orange-50',
  borderColor: 'border-orange-100',
  textColor: 'text-orange-900',
  bulletColor: 'text-orange-600'
}, {
  title: '📕 TOMO 4 — Neurodesarrollo y Regulación',
  desc: 'Para el niño que explota, que se bloquea, que no tolera los cambios o que hace crisis sin que sepas cómo manejarlo.',
  bullets: ['Perfil sensorial', 'Anticipación', 'Protocolo de crisis', 'Kit de regulación', 'Adaptaciones TEA/TDAH/ansiedad'],
  color: 'bg-red-50',
  borderColor: 'border-red-100',
  textColor: 'text-red-900',
  bulletColor: 'text-red-600'
}, {
  title: '📓 TOMO 5 — Sistema Estomatognático y Habla',
  desc: 'Para el niño que no articula, que respira por la boca, que deglute mal o que no tiene tono orofacial.',
  bullets: ['Conciencia orofacial', 'Labios y lengua', 'Respiración nasal', 'Deglución funcional', 'Dislalia', 'Automatización'],
  color: 'bg-gray-100',
  borderColor: 'border-gray-200',
  textColor: 'text-gray-900',
  bulletColor: 'text-gray-600'
}, {
  title: '📔 TOMO 6 — Laboratorio de Informes y Gestión Pro',
  desc: 'Para que nunca más pierdas tiempo en la parte administrativa que nadie te enseñó a sistematizar.',
  bullets: ['Anamnesis', 'Informes (evaluación, evolución, alta)', 'Registros de sesión', 'Reportes WhatsApp', 'Informe escolar', 'Protocolo de alta'],
  color: 'bg-yellow-50',
  borderColor: 'border-yellow-100',
  textColor: 'text-yellow-900',
  bulletColor: 'text-yellow-600'
}];
export function IncludesSection() {
  return <section className="py-20 bg-white" data-id="element-44">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-46">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 flex items-center justify-center gap-3" data-id="element-47">
            <span className="text-4xl" data-id="element-48">📦</span> ¿QUÉ INCLUYE EL MEGA PACK?
          </h2>
          <h3 className="text-xl md:text-2xl font-bold text-[#1B3A5C] mb-6" data-id="element-49">
            6 tomos interconectados · ~560 páginas · Niños de 3 a 12 años · 3
            niveles por tomo
          </h3>
          <div className="w-24 h-1 bg-[#C9A84C] mx-auto rounded-full" data-id="element-50" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-51">
          {tomos.map((tomo, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`${tomo.color} rounded-2xl p-6 border ${tomo.borderColor} shadow-sm hover:shadow-md transition-shadow`} data-id="element-52">
              <h4 className={`text-lg font-bold ${tomo.textColor} mb-3`} data-id="element-53">
                {tomo.title}
              </h4>
              <p className={`${tomo.textColor} opacity-90 font-medium mb-4 text-sm`} data-id="element-54">
                {tomo.desc}
              </p>
              <ul className="space-y-2" data-id="element-55">
                {tomo.bullets.map((bullet, i) => <li key={i} className={`flex items-start gap-2 text-sm ${tomo.textColor}`} data-id="element-56">
                    <span className={`${tomo.bulletColor} font-bold mt-0.5`} data-id="element-57">
                      ·
                    </span>
                    {bullet}
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-gray-900 rounded-2xl p-8 md:p-10 border border-gray-800 shadow-xl max-w-4xl mx-auto" data-id="element-58">
          <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-59">
            Cada conjunto de cada tomo incluye:
          </h4>
          <ul className="space-y-4" data-id="element-60">
            {['Ficha del profesional con objetivo clínico, base teórica, protocolo de sesión, indicadores y criterio de avance', '3 actividades del niño por sesión, adaptadas a cada edad, listas para imprimir', 'Ficha familiar con reporte de sesión y actividades para casa', 'Diploma de cierre de nivel y de tomo', 'Monitor de Evidencia Visual™ para mostrar avances a los padres'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-300" data-id="element-61">
                <CheckCircle2Icon className="w-6 h-6 text-[#22C55E] flex-shrink-0" data-id="element-62" />
                <span className="text-lg" data-id="element-63">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}